import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { FormattedEvent } from '../../../../event-renderer/src/types/events';
import DiscoverVerticalEventCard from '../DiscoverEventCard/DiscoverVerticalEventCard';
import styles from './PromotedEventCarousel.module.scss';

interface PromotedEventCarouselProps {
    events: FormattedEvent[];
    locale: string;
}

/**
 * Displays event search result ads in a dedicated, horizontally scrollable layout.
 *
 * @param props - The props for PromotedEventCarousel.
 * @param props.events - An array of FormattedEvent objects to display as promoted events.
 * @param props.locale - The locale to pass to each DiscoverVerticalEventCard.
 * @returns A React element rendering the promoted events carousel.
 */
const PromotedEventCarousel: React.FC<PromotedEventCarouselProps> = ({
    events,
    locale,
}) => (
    <div className={styles.promotedEventCarouselContainer}>
        <Typography variant="heading-sm" as="h2">
            Sponsored results
        </Typography>
        <div
            className={
                styles.promotedEventCarouselContainer__eventCardsContainer
            }
        >
            {events.map((event) => (
                <div
                    className={
                        styles.promotedEventCarouselContainer__eventCardWrapper
                    }
                    key={event.id}
                >
                    <DiscoverVerticalEventCard
                        event={event}
                        locale={locale}
                        isAuthenticated={true}
                    />
                </div>
            ))}
        </div>
    </div>
);

export default PromotedEventCarousel;
